/* 
  USER
*/	
	export const LOGIN = 'LOGIN'
	export const LOGOUT = 'LOGOUT'
	export const REGISTER = 'REGISTER'
	export const VERIFY_OTP = 'VERIFY_OTP'
	export const REFRESHTOKEN = 'REFRESHTOKEN'
	export const LOAD_USERS = 'LOAD_USERS'
	export const LOAD_PROFILE = 'LOAD_PROFILE'
	export const POST_USER_PROFILE = 'POST_USER_PROFILE'
	export const SIGNUP = 'SIGNUP'
	export const USER_BYID = 'USER_BYID'
	export const RESEND_OTP = 'RESEND_OTP'
	export const UPDATE_PROFILE = 'UPDATE_PROFILE'
	export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
	
	export const POST_ORGANIZATION_DETAILS = 'POST_ORGANIZATION_DETAILS'
	export const POST_ADMINISTRATOR_DETAILS = 'POST_ADMINISTRATOR_DETAILS'
	export const POST_PRODUCT_SELECTION = 'POST_PRODUCT_SELECTION'
	export const POST_FACILITY_DETAILS = 'POST_FACILITY_DETAILS'

	export const POST_UIM_FORECAST = 'POST_UIM_FORECAST'
	export const POST_UIM_FORECAST_DETAILS = 'POST_UIM_FORECAST_DETAILS'
	export const GET_UIM_FORECAST = 'GET_UIM_FORECAST'


	export const POST_PRODUCTION_LINES = 'POST_PRODUCTION_LINES'
	export const GET_PRODUCTION_LINES = 'GET_PRODUCTION_LINES'

    export const GET_FACILITY = 'GET_FACILITY'

	export const POST_ORGANIZATION_DOCUMENT = 'POST_ORGANIZATION_DOCUMENT'
	export const GET_MFG_PRODUCT = 'GET_MFG_PRODUCT'
	export const GET_MFG_PRODUCT_TYPE = 'GET_MFG_PRODUCT_TYPE'
	export const POST_FACILITY_DETAIL_REGISTER = 'POST_FACILITY_DETAIL_REGISTER'
	export const POST_REVIEW_AND_SUBMIT = 'POST_REVIEW_AND_SUBMIT'
	export const POST_ADD_USER = 'POST_ADD_USER'

	export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
	export const RESET_PASSWORD = 'RESET_PASSWORD'
    export const GET_USERS = 'GET_USERS'

/* 
  PARAMETERS
*/	
	export const GET_ADMIN_AREA = 'GET_ADMIN_AREA'	
	export const POST_ADMIN_AREA = 'POST_ADMIN_AREA'
	export const GET_REVENUE_SOURCE = 'GET_REVENUE_SOURCE'
	export const GET_ATTACHMENT_TYPES = 'GET_ATTACHMENT_TYPES'
	export const GET_ROAD = 'GET_ROAD'


/* 
  ORDER
*/	
	export const GET_PURCHASE_ORDER_LIST = 'GET_PURCHASE_ORDER_LIST'	
	export const POST_PURCHASE_ORDER = 'POST_PURCHASE_ORDER'

/* 
  BUSINESS
*/	
	export const GET_BSL = 'GET_BSL'	
	export const POST_BSL = 'POST_BSL'
	export const POST_BLD= 'POST_BLD'
	export const GET_BLD = 'GET_BLD'
	export const GET_INVOICE = 'GET_INVOICE'


/* 
  SOLID_WASTE
*/	
	export const GET_SOLID_WASTE = 'GET_SOLID_WASTE'	
	export const POST_SOLID_WASTE = 'POST_SOLID_WASTE' 

/* 
  INCLUDED
*/	
	export const GET_INCLUDED = 'GET_INCLUDED'	
	export const POST_INCLUDED = 'POST_INCLUDED'


/* 
  ITENARY
*/	
	export const GET_ITENARY = 'GET_ITENARY'	
	export const POST_ITENARY = 'POST_ITENARY'



/* 
  CATEGORY
*/	
	export const GET_CATEGORY = 'GET_CATEGORY'	
	export const POST_CATEGORY = 'POST_CATEGORY'	



/* 
  REVIEW
*/	
	export const GET_REVIEW = 'GET_REVIEW'	
	export const POST_REVIEW = 'POST_REVIEW'
	
	

/* 
  PLACES
*/	
	export const GET_PLACES = 'GET_PLACES'	
	export const POST_PLACES = 'POST_PLACES'
	


/*
	PACKAGE_PLACES
*/	
	export const GET_PACKAGE_PLACES = 'GET_PACKAGE_PLACES'	
	export const POST_PACKAGE_PLACES = 'POST_PACKAGE_PLACES'	


/*
	ADVERT
*/	
	export const GET_ADVERT = 'GET_ADVERT'	
	export const POST_ADVERT = 'POST_ADVERT'


/*
	USER
*/	
	export const GET_USER = 'GET_USER'	
	export const POST_USER = 'POST_USER'

/*
	BOOKING
*/	
	export const GET_BOOKING = 'GET_BOOKING'
	export const APPROVE_BOOKING = 'APPROVE_BOOKING'

/*
	WALLET
*/	
	export const GET_WALLET = 'GET_WALLET'


/*
	DASHBOARD_STATS
*/	
	export const GET_DASHBOARD_STATS = 'GET_DASHBOARD_STATS'


/* 
  LOCALE == CHANGE LANGUAGE
*/	
	export const CHANGE_LOCALE = 'CHANGE_LOCALE'



/*
	LOGS
*/	
	export const GET_LOGS = 'GET_LOGS'
